import PropTypes from 'prop-types';
import React from 'react';

import Formsy from 'formsy-react';
import { SheetFooter, Row, Col, Button, Label, FormGroup, SheetBody } from 'twyne-new.ui'

import URLView from '@Components/InputCopyURL';
import Input from '@Components/form/Input';
import Switch from '@Components/form/Switch';

class TokenForm extends React.Component {
  componentDidMount() {
    const { data } = this.props;
    if (data) {
      this.setState(data)
    }
  }

  handleValidSubmit = model => {
    this.props.handleSubmit({ ...this.state, ...model });
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Row>
            <Col size="12">
              <FormGroup>
                <Label>
                  Token
                </Label>
                <URLView value={this.state?.id} label="token" />
              </FormGroup>
            </Col>
            <Col size="12">
              <FormGroup>
                <Label>
                  Description
                </Label>
                <Input name='description' value={this.state?.description || ''} />
              </FormGroup>
            </Col>
            <Col size="3">
              <FormGroup>
                <Label>Active</Label>
                <Switch name="active" value={this.state?.active ?? true} />
              </FormGroup>
            </Col>
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.props.onCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}

TokenForm.propTypes = {
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.any,
};

export default TokenForm;
